export enum ViewType {
  Card,
  List,
    
}

